export default "__VITE_ASSET__9c4c749a__"